type SnapshotToneColors = {
  /** Card surface background — uses the lighter `*Variant` token for the tinted look. */
  background: string;
  /** Strong tone colour used for the primary value. */
  valueColor: string;
};

/**
 * Map a snapshot tone to the sys tokens used for the card background and value
 * text. The card is rendered as a fully tinted surface — no border accents.
 * Mirrors the styling pattern established in
 * `ovComponents/5-page/reconciliationV2/accountSnapshot.tsx`, which uses
 * `sys.color.<tone>Variant` for full-cell tinted backgrounds.
 */
export const getSnapshotToneColors = (
  tone: 'positive' | 'negative' | 'warning' | 'primary' | 'neutral',
  sys: { color: Record<string, string> },
): SnapshotToneColors => {
  switch (tone) {
    case 'positive':
      return {
        background: sys.color.positiveVariant,
        valueColor: sys.color.positive,
      };
    case 'negative':
      return {
        background: sys.color.negativeVariant,
        valueColor: sys.color.negative,
      };
    case 'warning':
      return {
        background: sys.color.warningVariant,
        valueColor: sys.color.warning,
      };
    case 'primary':
      return {
        background: sys.color.primaryVariant,
        valueColor: sys.color.primary,
      };
    default:
      return {
        background: sys.color.surface,
        valueColor: sys.color.onSurface,
      };
  }
};
